import { types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import { observable, action, makeObservable } from 'mobx'

type WebSocketConfig = {
  url: string,
  message: string
}

export class WebSocketProvider {
  data = {}
  config: WebSocketConfig
  websocket: WebSocket

  constructor (config: WebSocketConfig) {
    makeObservable(this, {
      data: observable,
      query: action
    })

    this.config = config
  }

  query = async _context => {
    if (this.websocket) this.websocket.close()
    this.websocket = new WebSocket(this.config.url)
    if (this.config.message) {
      this.websocket.onopen = () => {
        this.websocket.send(this.config.message)
      }
    }
    this.websocket.onmessage = action(e => {
      try {
        this.data = e.data && JSON.parse(e.data)
      } catch (e) {
        this.data = null
      }
    })
    return this.data
  }
}

export default t
  .model('WebSocket', {
    type: t.optional(t.string, 'WebSocket'),
    url: t.maybeNull(t.string),
    message: t.maybeNull(t.string),
    paths: t.optional(t.array(t.string), [])
  })
  .views(self => ({
    get provider () {
      return WebSocketProvider
    }
  }))
  .views(self => ({
    labels () {
      return {
        key: (self as any).id as string,
        label: (self as any).name as string,
        childNodes: [
          {
            key: 'data',
            label: 'Data',
            isExpanded: false,
            childNodes: self.paths.map(p => ({
              key: p,
              label: p,
              isExpanded: false
            }))
          }
        ]
      }
    }
  }))
  .actions(crudActions)
